import { render, staticRenderFns } from "./recognizeIndex.vue?vue&type=template&id=1345bce4&scoped=true"
import script from "./recognizeIndex.vue?vue&type=script&lang=js"
export * from "./recognizeIndex.vue?vue&type=script&lang=js"
import style0 from "./recognizeIndex.vue?vue&type=style&index=0&id=1345bce4&prod&lang=css"
import style1 from "./recognizeIndex.vue?vue&type=style&index=1&id=1345bce4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345bce4",
  null
  
)

export default component.exports